var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 174,
    height: 117,
    viewBox: "0 0 174 117",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M131.135 108.2H7.86504L0.165039 116.2V67.6902C0.165038 64.8541 1.29099 62.1341 3.29546 60.1277C5.29994 58.1214 8.01896 56.9929 10.855 56.9902H131.135C133.971 56.9929 136.69 58.1214 138.695 60.1277C140.699 62.1341 141.825 64.8541 141.825 67.6902V97.5202C141.82 100.353 140.691 103.068 138.688 105.07C136.684 107.072 133.968 108.198 131.135 108.2Z",
    fill: "#E2E2E2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1353 69.5195H126.135",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1353 81.5195H126.135",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1353 93.5195H104.135",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M86.8553 41.2H166.135L173.835 49.2V10.69C173.833 7.85393 172.704 5.13491 170.698 3.13044C168.691 1.12596 165.971 1.74636e-05 163.135 1.87021e-05H86.8553C85.4493 -0.00260992 84.0566 0.271881 82.7567 0.807804C81.4569 1.34373 80.2754 2.13057 79.2798 3.12336C78.2842 4.11615 77.4941 5.29542 76.9545 6.59375C76.415 7.89209 76.1366 9.28403 76.1353 10.69V30.52C76.1379 31.9252 76.4172 33.316 76.9574 34.6132C77.4975 35.9104 78.2879 37.0885 79.2833 38.0802C80.2788 39.0719 81.4598 39.8579 82.759 40.3932C84.0582 40.9285 85.4501 41.2026 86.8553 41.2Z",
    fill: "#E4E7EA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M86.8553 41.2H166.135L173.835 49.2V10.69C173.833 7.85393 172.704 5.13491 170.698 3.13044C168.691 1.12596 165.971 1.74636e-05 163.135 1.87021e-05H86.8553C85.4493 -0.00260992 84.0566 0.271881 82.7567 0.807804C81.4569 1.34373 80.2754 2.13057 79.2798 3.12336C78.2842 4.11615 77.4941 5.29542 76.9545 6.59375C76.415 7.89209 76.1366 9.28403 76.1353 10.69V30.52C76.1379 31.9252 76.4172 33.316 76.9574 34.6132C77.4975 35.9104 78.2879 37.0885 79.2833 38.0802C80.2788 39.0719 81.4598 39.8579 82.759 40.3932C84.0582 40.9285 85.4501 41.2026 86.8553 41.2Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M159.135 14.5195H92.1353",
    stroke: "#BEC2CB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M137.135 26.5195H92.1353",
    stroke: "#BEC2CB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M86.8553 41.2H166.135L173.835 49.2V10.69C173.833 7.85393 172.704 5.13491 170.698 3.13044C168.691 1.12596 165.971 1.74636e-05 163.135 1.87021e-05H86.8553C85.4493 -0.00260992 84.0566 0.271881 82.7567 0.807804C81.4569 1.34373 80.2754 2.13057 79.2798 3.12336C78.2842 4.11615 77.4941 5.29542 76.9545 6.59375C76.415 7.89209 76.1366 9.28403 76.1353 10.69V30.52C76.1379 31.9252 76.4172 33.316 76.9574 34.6132C77.4975 35.9104 78.2879 37.0885 79.2833 38.0802C80.2788 39.0719 81.4598 39.8579 82.759 40.3932C84.0582 40.9285 85.4501 41.2026 86.8553 41.2Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.0ae45523f7c656adcc86fc4c709ff4a6.svg";
export { ForwardRef as ReactComponent };